import { useEffect, useState } from "react";
import { anomaliesQueries, useAnomaliesService } from "../../../../../services/anomalieService";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LocalClientToken } from "../../../../../utils/local-client-token";

export function useAnomaliesHook() {
    const anomaliesService = useAnomaliesService();
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    const {fkAssetId} = useParams();

    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
        const handlePopState = () => {
            if (location.pathname === "/anomalies") {
                navigate("/adm");
            }else{
                navigate("/");
            }
        };

        // Detecta mudanças no histórico
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };}
    );

    const {
        data: anomaliesData,
        isLoading: isLoadingAnomalies,
        isRefetching: isRefetchingAnomalies,
        refetch: refetchAnomalies
        //TODO: trocar a paginacao
    } = useQuery(anomaliesQueries.GET_ALL, () => anomaliesService.getWithoutPositionAnomalies({ page: 1, fkAssetId, search }));



    return {
        anomalies: {
            anomaliesData,
            isLoading : isLoadingAnomalies | isRefetchingAnomalies,
            refetchAnomalies,
            setSearch
        },
        navigate,
        pathname

    }
}